import { GetStaticProps } from "next";
import { ForgetPassword } from "../../../../components/ForgetPassword";
import AuthPage from "../../../../components/pages/platform/AuthPage";
import Layout from "../../../../components/layouts/PlatformLayout";

export default function Platform({ user, networks }) {
    return <Layout user={user}><AuthPage noAuth user={user} slug={"forgot_password"} networks={networks} title={"Forgot Password?"}><ForgetPassword /></AuthPage></Layout>;
}

export const getStaticProps: GetStaticProps = async () => {
    return {
        props: {
            component: "Platform",
        },
    };
};